<template>
    <v-container class="webbox-description-styling">
        <label class="v-label d-block mt-5">{{$t('webboxes.styling.description.title')}}</label>
        <v-switch
                v-model="customLength"
                :label="$t('webboxes.styling.description.label')"
                class="pr-3"
            />
        <v-slider
          v-model="maxLengthInt"
          :disabled="!customLength"
          :thumb-label="true"
          hide-details
          class="align-center pr-3"
          min="0"
          max="150"
        >
                <template v-slot:prepend>
                <v-text-field
                v-model.number="maxLengthInt"
                class="mt-0 pt-0"
                hide-details
                single-line
                min="0"
                max="150"
                type="number"
                style="width: 120px"
                :suffix="$t('webboxes.styling.description.suffix')"
              ></v-text-field>
            </template>
            </v-slider>
    </v-container>
</template>
<script>
export default {
    name: 'DescriptionStyling',
    props: { maxLength: Number },
    data() {
        return {
            customLength: !!this.maxLength
        }
    },
    watch: {
        customLength(val) {
            if(!val) {
                this.$emit(`update:maxLength`, null);
            }
        }
    },
    computed: {
        maxLengthInt: {
            get() {
                return this.maxLength;
            },
            set(val) {
                if(this.customLength) {
                    this.$emit(`update:maxLength`, val);
                }
            }
        }
    },
    methods: {
    }
}
</script>